import React from "react";
import { Button } from "../ui/button";
import { bidInterest } from "services";

interface AcknowledgementCardProps {
  name: string;
  message: string;
  hideBottomActions?: boolean;
  hideEmailSection?: boolean;
  contactInfo: {
    mobileNumber: string;
    email?: string;
  };
  handleInterested: any;
  handleNotInterested: any;
}
/*
 <AcknowledgementCard
            name="Rahul"
            message="We will also share the officer details via WhatsApp."
            contactInfo={{
              mobileNumber: "+91 9823456723",
              email: "amankumar@gmail.com",
            }}
          />


const handleBidInterest = async () => {
    const payload: { name: string; mobile_number?: string; email?: string } = {
      name,
    };

    if (contactInfo?.mobileNumber?.length === 10) {
      payload.mobile_number = contactInfo.mobileNumber;
    }

    if (contactInfo.email && contactInfo?.email?.length > 3) {
      payload.email = contactInfo.email;
    }

    try {
      await bidInterest(payload);
    } catch (error) {
      console.error("Error handling bid interest:", error);
    }
  };
*/

export default function AcknowledgementCard({
  name,
  message,
  contactInfo,
  hideBottomActions = false,
  hideEmailSection = false,
  handleInterested,
  handleNotInterested,
}: AcknowledgementCardProps) {
  return (
    <section className="">
      {/* Heading */}
      <div className="font-openSans text-xl font-semibold text-brand-textBlack">
        Thank You {name},
      </div>

      {/* Message */}
      <p className="text-sm font-openSans text-[#717272] mt-2">{message}</p>

      {/* Contact Information */}
      <div className="bg-[#F6F6F6] px-4 pt-4 pb-8 mt-6 mb-36">
        <h4 className="text-sm font-openSans font-semibold text-brand-textBlack capitalize">
          Information
        </h4>
        <div className="mt-4 flex justify-between items-center">
          <div>
            <p className="whitespace-nowrap text-sm font-openSans text-brand-textGrey">
              Mobile Number
            </p>
          </div>
          <p className="text-sm font-openSans text-brand-textGrey">
            {contactInfo.mobileNumber}
          </p>
        </div>
        {!hideEmailSection && (
          <div className="flex justify-between items-center mt-3 gap-x-3">
            <div>
              <p className="whitespace-nowrap text-sm font-openSans text-brand-textGrey">
                Email ID
              </p>
            </div>
            <p className="break-all text-sm font-openSans text-brand-textGrey">
              {contactInfo.email}
            </p>
          </div>
        )}
      </div>
      {!hideBottomActions && (
        <div className="flex flex-col gap-y-[13px]">
          <Button onClick={handleInterested}>
            Interested in this Property
          </Button>
          <Button
            className="bg-white hover:bg-white text-brand-textBlack border-[1px]"
            onClick={handleNotInterested}
          >
            Not Interested
          </Button>
        </div>
      )}
    </section>
  );
}
